import { Avatar, Box, Divider, Grid, List, SxProps, Typography, ListItem, ListItemAvatar, ListItemText, Button } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import type { NewsData } from "../../data/NewsData";
import { ResponsiveStyleValue } from '@mui/system';
import { DefaultSetting } from '../defaultSetting';
import * as Lodash from "lodash";
import { yyyymmdd } from '../../system/Features/YYYYMMDD';


interface ListBoxProps {
    data: Array<NewsData>,
    borderRadius?: string,
    sx?: SxProps,
    height?: ResponsiveStyleValue<string | number>,
}

export function NewsBox(props: ListBoxProps) {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const timer = window.setInterval(() => setNow(new Date()), 60 * 1000);
        return () => window.clearInterval(timer);
    }, []);

    const visibleNewsData = useMemo(() => {
        return Lodash.take(
            props.data.filter((item: NewsData) => !item.publishAt || item.publishAt.getTime() <= now.getTime()),
            6
        );
    }, [props.data, now]);

    return <Box sx={{ backgroundColor: DefaultSetting.mainBackgroundColor, height: props.height, ...props.sx }} borderRadius={DefaultSetting.borderRadius}>
        {props.data &&
            <Box sx={{ p: 1 }}>
                <Grid container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-end"
                >
                    <Typography variant="h6" component="div" sx={{ color: DefaultSetting.mainColor, textAlign: "left" }}>
                        &#128240; 最新資訊
                    </Typography>
                    <Button sx={{ p: 0 }}>
                        {
                            // <Typography sx={{ textAlign: "right" }} variant="caption">看更多</Typography> 
                        }
                    </Button>
                </Grid>
                <Divider />
                <List>
                    {visibleNewsData.map((item: NewsData, idx: number) => (
                        <Fragment key={`${item.content}-${item.date.toISOString()}`}>
                            <ListItem onClick={() => item.onClick()} sx={{ cursor: "pointer", borderRadius: "10px", ...DefaultSetting.hoverZoomAni }}>
                                <ListItemAvatar>
                                    <Avatar sx={{ bgcolor: DefaultSetting.mainColor }}>{item.icon}</Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={item.content} secondary={yyyymmdd(new Date(item.date))} />
                            </ListItem>
                            {
                                (idx <= 4) &&
                                <Divider variant="inset" component="li"/>
                            }
                        </Fragment>
                    ))}
                </List>
            </Box>

        }
    </Box>
}